import { render, staticRenderFns } from "./TheSignUp.vue?vue&type=template&id=5ff15bbf&scoped=true"
import script from "./TheSignUp.vue?vue&type=script&lang=ts"
export * from "./TheSignUp.vue?vue&type=script&lang=ts"
import style0 from "./TheSignUp.vue?vue&type=style&index=0&id=5ff15bbf&scoped=true&lang=scss"
import style1 from "./TheSignUp.vue?vue&type=style&index=1&id=5ff15bbf&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff15bbf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ff15bbf')) {
      api.createRecord('5ff15bbf', component.options)
    } else {
      api.reload('5ff15bbf', component.options)
    }
    module.hot.accept("./TheSignUp.vue?vue&type=template&id=5ff15bbf&scoped=true", function () {
      api.rerender('5ff15bbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheSignUp.vue"
export default component.exports